// src/context/AuthContext.js
import React, { createContext, useState, useContext } from 'react';

export const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }) => {
  const [fullMenu, setFullMenu] = useState(false);
  const [username, setUserName] = useState('');
  // running portfolio process
  const [isProcessRunning, setIsProcessRunning] = useState(false)

  const toggHeader = () => {
    setFullMenu((value) => !value)
};
  return (
    <AppContext.Provider value={{ fullMenu, toggHeader, isProcessRunning, setIsProcessRunning }}>
      {children}
    </AppContext.Provider>
  );
};
